import Header from "@buddieshr/components/header";
import MetaHeader from "@buddieshr/components/metaHeader";
import PageWrapper from "@buddieshr/components/templates/pageWrapper";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "@buddieshr/styles/alternatives.module.scss";
import { useRouter } from "next/router";
import Argument from "@buddieshr/components/templates/argument";
import InstallNow from "@buddieshr/components/installNow";
import Footer from "@buddieshr/components/footer";
import AddToSlackButton from "@buddieshr/components/addToSlackButton";
import {
  DollarCircleOutlined,
  HeartOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import TextColored from "@buddieshr/components/text/textColored";
import TextUnderlined from "@buddieshr/components/text/textUnderlined";
import Image from "next/image";
import ComparisonTable from "@buddieshr/components/comparisonTable";
import { PRICE_BUDDIESHR, VERSUS_AIRSPEED } from "@buddieshr/utils/constants";
// import UsedByLogoBanner from "@buddieshr/components/usedByLogoBanner";
import { PRODUCTS } from "@buddieshr/utils/constants-products";

const ALTERNATIVE_NAME = "Shuffl";
const ALTERNATIVE_NAME_SHORT = "Shuffl";

const AlternativeAirspeed = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const app = PRODUCTS.find((c) => c.id === "Alfy");
  return (
    <>
      <MetaHeader
        title={t("metaTitleshuffl")}
        description={t("descriptionContentshuffl")}
        currentURL={`https://buddieshr.com/${
          router.locale === "en" ? "" : router.locale
        }/${app.urlSlug || app.slug}/alternatives/shuffl`}
        currentShare={
          "https://buddieshr.com/img/apps/alfy/alternatives/shuffl_versus_alfy.png"
        }
        pageSlug={`${app.urlSlug || app.slug}/alternatives/shuffl`}
        locale={router.locale}
      />
      <Header app={app} />
      <main className={styles.main}>
        <div className={styles.topPanel}>
          <PageWrapper>
            <div className={styles.flexInner}>
              <div className={styles.flexLeft}>
                <h1 className={styles.title}>
                  Discover the <TextColored>best alternative</TextColored> to{" "}
                  {ALTERNATIVE_NAME}
                </h1>
                <div className={styles.description}>
                  How does Alfy compare to {ALTERNATIVE_NAME} Slack app? What
                  the best way to{" "}
                  <a href="https://buddieshr.com/random-coffee">
                    connect employees
                  </a>{" "}
                  together? What’s the best alternative to {ALTERNATIVE_NAME}{" "}
                  Slack bot?
                  <br />
                  <br />
                  Discover why Alfy is a great alternative to {ALTERNATIVE_NAME}
                  .
                </div>
                <div>
                  <AddToSlackButton app={app} />
                </div>
              </div>
              <div className={styles.flexRight}>
                <Image
                  src="/img/apps/alfy/alternatives/shuffl_versus_alfy.png"
                  width={367}
                  height={300}
                  alt="shuffl alternatives random coffee"
                />
              </div>
            </div>
          </PageWrapper>
        </div>

        <div className={styles.socialProofWrapper}>
          {/* <UsedByLogoBanner /> */}
        </div>
        <div className={styles.top3Reasons}>
          <PageWrapper>
            <h2 className={styles.h2}>
              Top 3 reasons Alfy is the best alternative to {ALTERNATIVE_NAME}
            </h2>
            <div>
              Here are the main reasons why people prefer Alfy over{" "}
              {ALTERNATIVE_NAME}
            </div>
            <div className={styles.reasonWrapper}>
              <div className={styles.reasonElement}>
                <div className={styles.reasonLogo}>
                  <TeamOutlined />
                </div>
                <div className={styles.reasonTitle}>
                  <TextColored>Customisable matching algorithm</TextColored>
                </div>
                <div className={styles.reasonDesc}>
                  With Alfy, get relevant, non-redondant matchings that maximise
                  team bonding and interesting conversations.
                </div>
              </div>
              <div className={styles.reasonElement}>
                <div className={styles.reasonLogo}>
                  <DollarCircleOutlined />
                </div>
                <div className={styles.reasonTitle}>
                  <TextColored>Alfy is (way) cheaper</TextColored>
                </div>
                <div className={styles.reasonDesc}>
                  Free under 10 users, affordable above that (${PRICE_BUDDIESHR.ONE_APP.MONTHLY} per user per
                  month). Way cheaper than {ALTERNATIVE_NAME_SHORT} ($3-4 per
                  user per month).
                </div>
              </div>
              <div className={styles.reasonElement}>
                <div className={styles.reasonLogo}>
                  <HeartOutlined />
                </div>
                <div className={styles.reasonTitle}>
                  <TextColored>UX people love</TextColored>
                </div>
                <div className={styles.reasonDesc}>
                  With Alfy, get a fresh, simple user interface 100% in Slack.
                </div>
              </div>
            </div>
          </PageWrapper>
        </div>
        <div className={styles.top3Reasons}>
          <PageWrapper>
            <div className={styles.flexInner}>
              <div className={styles.flexLeft}>
                <h3 className={styles.h2}>
                  Looking for an{" "}
                  <TextUnderlined>
                    alternative to {ALTERNATIVE_NAME} Slack app?
                  </TextUnderlined>
                </h3>
                <div>
                  <Image
                    src="/img/alternative.png"
                    width={400}
                    height={400}
                    alt={`best Alternative to ${ALTERNATIVE_NAME}`}
                  />
                </div>
              </div>
              <div className={styles.flexRight}>
                <div className={styles.whatITitle}>
                  What is {ALTERNATIVE_NAME}
                </div>
                <div className={styles.descColor}>
                  {ALTERNATIVE_NAME} is a Slack app to build a culture of trust
                  with meaningful meetings. Colleagues can connect, discover
                  common ground and spark bonds instantly before meeting.
                  Strengthen engagement by using shuffl match history to find
                  new shuffl combinations in future intros automatically.
                </div>
                <br />
                <br />
                <div className={styles.whatITitle}>What is Alfy Matching</div>
                <div className={styles.descColor}>
                  Alfy is a Slack app helping teams connect with each other. It
                  can match coworkers for a coffee break every week creating
                  team bonding, camaraderie, streamlining collaboration and
                  productivity.
                </div>
              </div>
            </div>
          </PageWrapper>
        </div>
        <div className={styles.arguments}>
          <PageWrapper>
            <Argument
              title="Get the most customisable matching algorithm"
              tag="#Reason 1"
              description="Get relevant, non-redondant matchings that maximise team bonding and interesting conversations."
              pictureUrl={"/img/coffee.png"}
              color="#e5ebfe"
            />
            <br />
            <br />
            <Argument
              title={`Alfy is cheaper, ${ALTERNATIVE_NAME_SHORT} costs $3-4 per employee for 50 employees where Alfy is at ${PRICE_BUDDIESHR.ONE_APP.MONTHLY} per employee.`}
              tag="#Reason 2"
              description={`From a costs perspective, Alfy will be your go-to choice because it makes quite a huge difference no matter how many employees you have. Not only Alfy is free for teams under 10 but is also way cheaper than ${ALTERNATIVE_NAME} if your team is larger than 50.`}
              pictureUrl={"/img/friend.png"}
              color="#e5ebfe"
              reverse
            />
            <br />
            <br />
            <Argument
              title="Simpler User Experience"
              tag="#Reason 3"
              description="Shuffl can become a bit clunky to use. The interface is not optimised anymore. Many users complain about the complexity to setup a simple initiative like matching employees together. It doesn't happen with Alfy which has a modern, easy-to-use, simple interface fully integrated inside Slack. "
              pictureUrl={"/img/group.png"}
              color="#e5ebfe"
            />
          </PageWrapper>
        </div>

        <div className={styles.comparisonWrapper}>
          <PageWrapper>
            <ComparisonTable
              features={VERSUS_AIRSPEED}
              competitorName={ALTERNATIVE_NAME}
              competitorLogoUrl="/img/apps/alfy/alternatives/shuffl.png"
              app={app}
            />
          </PageWrapper>
        </div>
        {/* <div className={styles.benefitsWrapper}>
          <PageWrapper>BENEFITS</PageWrapper>
        </div> */}
        <div className={styles.installNowWrapper}>
          <InstallNow
            app={app}
            gradient={app.gradient}
            title="Ready to Build better relationships at work?"
            subtitle="Impact your team today. Get started now."
          />
        </div>
      </main>
      <Footer app={app} />
    </>
  );
};

export default AlternativeAirspeed;
